import React, {Component} from 'react';
import {
    IconButton,
    Card,
    Grid,
    Checkbox,
    Tooltip,
    Popover,
    Typography,
} from '@material-ui/core';
import Counter from 'Components/counter/Counter';
import Anchor from 'Components/common/Anchor';
import {DeleteForever, ExpandLess, ExpandMore} from '@material-ui/icons';
import {T} from 'Actions/translate';
import {Info} from '@material-ui/icons';

class F1ShoppingCart extends Component {
    state = {
        num: 0,
        checked: true,
        f1CartLotsInfo: {},
    };

    componentWillMount() {
        let {f1CartSelectedLotsInfor} = this.props;
        if (JSON.stringify(f1CartSelectedLotsInfor) !== '{}') {
            f1CartSelectedLotsInfor.f1SkuCacheModel.isViewOtherLotInfo = false;
        }

        this.setState({
            f1CartLotsInfo: f1CartSelectedLotsInfor,
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.defaultCheck !== this.props.defaultCheck) {
            this.setState({
                checked: nextProps.defaultCheck,
            });
        }
    }

    changeNum = (value) => {
        this.setState({
            num: value,
        });
        if (this.props.changeNum) {
            this.props.changeNum(this.props.f1CartInfo, value);
        }
    };

    handleCheck = (name) => (event) => {
        this.setState({[name]: event.target.checked});
        if (this.props.handleCheck) {
            this.props.handleCheck(
                event.target.checked,
                this.state.num || this.props.f1CartInfo.quantity,
                this.props.f1CartInfo.id,
            );
        }
    };

    addShowDefaultValue = (tempF1CartInfo) => {
        tempF1CartInfo.f1SkuCacheModel.isViewOtherLotInfo = false;
        this.setState({
            f1CartLotsInfo: tempF1CartInfo,
        });
    };

    handleViewF1LotInfor = (tempF1CartInfo) => {
        if (tempF1CartInfo.f1SkuCacheModel.isViewOtherLotInfo) {
            tempF1CartInfo.f1SkuCacheModel.isViewOtherLotInfo = false;
        } else {
            tempF1CartInfo.f1SkuCacheModel.isViewOtherLotInfo = true;
        }
        this.setState({
            f1CartLotsInfo: tempF1CartInfo,
        });
    };

    render() {
        let {f1CartInfo, f1CartSelectedLotsInfor} = this.props;
        const {checked} = this.state;

        return (
            <Card className="f1_shopping_cart">
                {f1CartInfo.product.grayFlag === 'Y' ? (
                    <div className="gray-sku-info">
                        <Info className="sku-info" />
                        {T('notification_gray_list_info')}
                    </div>
                ) : null}
                <div className="f1-shopping_cart_sku">
                    <div className="checkbox">
                        <Checkbox
                            checked={checked}
                            onChange={this.handleCheck('checked')}
                        />
                    </div>

                    <div className="adjust-width">
                        <Grid
                            className="cart-content"
                            container
                            spacing={0}
                            justify={'space-evenly'}>
                            <Grid className="right-content-grid" item xs={7}>
                                <Grid
                                    container
                                    spacing={0}
                                    justify={'space-evenly'}>
                                    <Grid className="sku-grid" item xs={12}>
                                        <span>{f1CartInfo.product.sku}</span>
                                        <span
                                            className="inventory-btn"
                                            onClick={this.props.inventoryDetails.bind(
                                                this,
                                                f1CartInfo.product.sku,
                                                f1CartInfo.id,
                                                f1CartInfo,
                                                f1CartSelectedLotsInfor,
                                            )}>
                                            {T('company_stock')}
                                        </span>
                                    </Grid>

                                    <Grid
                                        className="specifications-grid"
                                        item
                                        xs={12}>
                                        <span>
                                            {T(
                                                'fone_order_specifications_colon',
                                            )}
                                            <span
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        f1CartInfo.product
                                                            .specifications,
                                                }}
                                            />
                                        </span>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid className="counter-grid" item xs={4}>
                                <Counter
                                    inputValid={this.changeNum}
                                    defalutValue={f1CartInfo.quantity}
                                    options={{value: 0, min: 1}}></Counter>
                            </Grid>

                            <Grid className="delete-icon" item xs={1}>
                                <IconButton
                                    color="inherit"
                                    onClick={this.props.deleteF1Item.bind(
                                        this,
                                        f1CartInfo,
                                    )}>
                                    <DeleteForever />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </div>
                </div>
                <div className="lot-infor-container">
                    <div className="expiry-date-label">
                        {f1CartSelectedLotsInfor.isHitCache
                            ? T('fone_order_selected_lot')
                            : !f1CartSelectedLotsInfor.f1SkuCacheModel
                                  .skuLotInfoList ||
                              f1CartSelectedLotsInfor.f1SkuCacheModel
                                  .skuLotInfoList.length === 0
                            ? T('fone_order_out_stock')
                            : T('fone_order_recent_lot')}
                    </div>

                    <div className="show-selected-lot-infor">
                        <div className="all-lot-infor-container">
                            {f1CartSelectedLotsInfor.f1SkuCacheModel
                                .skuLotInfoList &&
                            f1CartSelectedLotsInfor.f1SkuCacheModel
                                .skuLotInfoList.length > 0 ? (
                                <ul className="expiry-data-content">
                                    {f1CartSelectedLotsInfor.f1SkuCacheModel.skuLotInfoList.map(
                                        (skuLotInfoItem, index) =>
                                            f1CartSelectedLotsInfor
                                                .f1SkuCacheModel
                                                .isViewOtherLotInfo ? (
                                                <li
                                                    className={
                                                        'f1-lot-infor-' +
                                                        (parseInt(index) + 1)
                                                    }>
                                                    <div className="first-row">
                                                        <div className="first-column">
                                                            <label>
                                                                {T(
                                                                    'fone_order_expiry_date_lot',
                                                                )}
                                                            </label>
                                                            {skuLotInfoItem.lot}
                                                        </div>
                                                        <div className="second-column">
                                                            <label>
                                                                {T(
                                                                    'host_abnormal_nubmer_colon',
                                                                )}
                                                            </label>
                                                            {
                                                                skuLotInfoItem.availableQuantity
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="sencond-row">
                                                        <div className="first-column">
                                                            <label>
                                                                {T('warehouse')}
                                                            </label>
                                                            {
                                                                skuLotInfoItem.branchDesc
                                                            }
                                                        </div>
                                                        <div className="second-column">
                                                            <label>
                                                                {T(
                                                                    'host_advent_products_expiration_date',
                                                                )}
                                                            </label>
                                                            {
                                                                skuLotInfoItem.lotExpirationDate
                                                            }
                                                        </div>
                                                    </div>
                                                </li>
                                            ) : (
                                                parseInt(index) + 1 < 2 && (
                                                    <li
                                                        className={
                                                            'f1-lot-infor-' +
                                                            (parseInt(index) +
                                                                1)
                                                        }>
                                                        <div className="first-row">
                                                            <div className="first-column">
                                                                <label>
                                                                    {T(
                                                                        'fone_order_expiry_date_lot',
                                                                    )}
                                                                </label>
                                                                {
                                                                    skuLotInfoItem.lot
                                                                }
                                                            </div>
                                                            <div className="second-column">
                                                                <label>
                                                                    {T(
                                                                        'host_abnormal_nubmer_colon',
                                                                    )}
                                                                </label>
                                                                {
                                                                    skuLotInfoItem.availableQuantity
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="sencond-row">
                                                            <div className="first-column">
                                                                <label>
                                                                    {T(
                                                                        'warehouse',
                                                                    )}
                                                                </label>
                                                                {
                                                                    skuLotInfoItem.branchDesc
                                                                }
                                                            </div>
                                                            <div className="second-column">
                                                                <label>
                                                                    {T(
                                                                        'host_advent_products_expiration_date',
                                                                    )}
                                                                </label>
                                                                {
                                                                    skuLotInfoItem.lotExpirationDate
                                                                }
                                                            </div>
                                                        </div>
                                                    </li>
                                                )
                                            ),
                                    )}
                                </ul>
                            ) : null}
                            {f1CartSelectedLotsInfor.f1SkuCacheModel.skuLotReqs
                                .length > 0 ? (
                                <div className="time-filter-options">
                                    {f1CartSelectedLotsInfor.f1SkuCacheModel.skuLotReqs.map(
                                        (optionItem, optionIndex) => (
                                            <div className="time-option">
                                                {optionItem === 'HALF_YEAR'
                                                    ? T('fone_order_half_year')
                                                    : optionItem === 'ONE_YEAR'
                                                    ? T('fone_order_one_year')
                                                    : T('fone_order_same_lot')}
                                            </div>
                                        ),
                                    )}
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
                {f1CartSelectedLotsInfor.isHitCache &&
                f1CartSelectedLotsInfor.f1SkuCacheModel.skuLotInfoList &&
                f1CartSelectedLotsInfor.f1SkuCacheModel.skuLotInfoList.length >
                    1 ? (
                    <div className="view-lot-infor">
                            
                        <Anchor
                            className="show-lot-icon"
                            onClickOfSingleTap={() => {
                                this.handleViewF1LotInfor(
                                    f1CartSelectedLotsInfor,
                                );
                            }}>
                            {f1CartSelectedLotsInfor.f1SkuCacheModel
                                .isViewOtherLotInfo ? (
                                <ExpandLess />
                            ) : (
                                <ExpandMore />
                            )}
                        </Anchor>
                                        
                    </div>
                ) : null}
            </Card>
        );
    }
}

export default F1ShoppingCart;
